import jQuery from 'jquery';
import { Buffer } from 'buffer';
import process from 'process';

window.$ = jQuery;
window.jQuery = jQuery;
window.Buffer = Buffer;
window.process = process;
